import validate from 'validate.js';

const constraints = {
    email: {
	email: {
	    message: 'napiši email'
	},
	presence: { 
	    message: 'napiši email'
	}
    },
    password: {
	presence: { 
	    message: 'napiši geslo'
	}
    }
}

const LoginValidator = ( fields ) => {
    return validate(fields, constraints, {fullMessages: false}) || {};
}

export default LoginValidator ;



// WEBPACK FOOTER //
// ./src/validators/LoginValidator.js